const { parseCurrency } = require('./numbers')

const parseStore = ({
  delayFeePerMinute,
  hasCommissions,
  hasRentSignature,
  hasDepositPhotos,
  isDepositPhotoRequired,
  hasCheckoutClosingNotebookPhotos,
  isCheckoutClosingNotebookPhotoRequired,
  hasCheckoutMachineReceiptPhotos,
  isCheckoutMachineReceiptPhotoRequired,
  ...store
}) => ({
  ...store,
  hasCommissions: Boolean(hasCommissions),
  hasRentSignature: Boolean(hasRentSignature),
  hasDepositPhotos: Boolean(hasDepositPhotos),
  isDepositPhotoRequired: Boolean(hasDepositPhotos && isDepositPhotoRequired),
  hasCheckoutClosingNotebookPhotos: Boolean(hasCheckoutClosingNotebookPhotos),
  isCheckoutClosingNotebookPhotoRequired: Boolean(
    hasCheckoutClosingNotebookPhotos && isCheckoutClosingNotebookPhotoRequired
  ),
  hasCheckoutMachineReceiptPhotos: Boolean(hasCheckoutMachineReceiptPhotos),
  isCheckoutMachineReceiptPhotoRequired: Boolean(
    hasCheckoutMachineReceiptPhotos && isCheckoutMachineReceiptPhotoRequired
  ),
  delayFeePerMinute: parseCurrency(delayFeePerMinute)
})

export { parseStore }
